import React from 'react';
import ImgCover from "img/login";
import {Link} from "react-router-dom";
import useLogin from "v4/pages/front/Login/hooks/useLogin";
import {useTranslation} from "react-i18next";
import {routesBase} from "v4/data/appRoutes";
import LoginModelPage from "v4/pages/front/Login/components/LoginModelPage";
import FormRender from "v4/components/form/FormRender/FormRender";
import LoginField from "v4/pages/front/Login/components/LoginField";
import FormRest from "v4/components/form/FormRender/components/FormRest/FormRest";
import FormSubmitButton from "v4/components/form/FormRender/components/FormSubmitButton/FormSubmitButton";

export default function LoginPage() {
    const {t} = useTranslation();

    const {
        form,
        onSubmit,
        formErrorMessage,
        isLocked,
        isLoading,
    } = useLogin();

    return (
        <LoginModelPage imageLeftRender={() => <ImgCover/>}>
            <FormRender form={form}
                        onSubmit={onSubmit}
                        fieldRender={(field, formRenderMethods) => (
                            <LoginField field={field}
                                        isDisabled={isLoading}
                                        formRenderMethods={formRenderMethods}/>
                        )}
            >
                <FormRest/>

                {formErrorMessage && <p className="login__form__error">{formErrorMessage}</p>}

                <div className="d-flex align-items-center">
                    <FormSubmitButton isLoading={isLoading}
                                      isDisabled={isLocked}
                                      additionalClassName="login__form__btn">
                        {t('login')}
                    </FormSubmitButton>
                    <p className="login__form__forget ml-4">
                        <Link to={routesBase.baseResetPassword}>
                            {t('mdp_oublie')}
                        </Link>
                    </p>
                </div>
            </FormRender>
        </LoginModelPage>
    )
}
